import React from "react";
import QRCode from "react-qr-code";
import "../index.css";
import picPlaceholder from "./people.jpg";

const MemberCard = ({ memberData, isPrintView }) => {
  return (
    <div className={`member-card p-3 ${isPrintView ? "print-view" : ""}`}>
      {memberData ? (
        <>
          {/* Display print count at the top */}
          {/* {!isPrintView && (
            <div className="print-count">
              Print Count: {memberData.printed || 0}
            </div>
          )} */}

          <div className="header-images d-flex justify-content-between">
            {memberData.photo ? (
              <img
                className="member-card-photo"
                src={
                  `http://localhost:3000/Images/Adherants/` + memberData.photo
                }
              />
            ) : (
              <img className="member-card-photo" src={picPlaceholder} />
            )}

            <div className="card-header">
              <h2 className="ESIA">ESIA</h2>
              <h6 className="esia-tel">Tel: +261 20 625 66</h6>
            </div>
            <QRCode
              className="qr-code-member-card"
              value={memberData.matricule}
              size={65}
            />
          </div>

          <div className="member-card-content">
            <p className="member-card-societe">{memberData.societe}</p>
            <p className="member-card-matricule">
              <span className="matricule-title">Mat: </span>
              {memberData.matricule} {memberData.assure ? "(AD)" : "(P)"}
            </p>
            <p className="member-card-nom">
              {memberData.prenom.toLowerCase()} {memberData.nom}{" "}
            </p>
          </div>
          {!memberData.isactive && <div className="inactive-member-icon"></div>}
        </>
      ) : (
        <p>Loading member data...</p>
      )}
    </div>
  );
};

export default MemberCard;
